import Cookies from 'universal-cookie';
class SingletonCookies {
    static _instance = null;
    static instance = this._instance ?? new SingletonCookies();
    cookies;
    constructor() {
        this.cookies = new Cookies();
        SingletonCookies._instance ??= this;
    }
}
const cookies = SingletonCookies.instance.cookies;
export const CookieManager = (org) => {
    const globalCookie = cookies;
    function setCookies(name, value, options) {
        cookies.set(`${org}/${name}`, value, options);
    }
    function deleteCookie(name, options) {
        cookies.remove(`${org}/${name}`, options);
    }
    function deleteAllCookies() {
        const cookiesList = cookies.getAll();
        const cookieNames = Object.keys(cookiesList);
        const arrayNeedDel = cookieNames.filter(item => item.startsWith(org));
        arrayNeedDel.forEach(name => cookies.remove(name));
    }
    return {
        cookieChange: globalCookie,
        setCookies,
        getCookie: (name, options) => {
            const value = cookies.get(`${org}/${name}`, options);
            return value;
        },
        deleteCookie,
        deleteAllCookies,
    };
};
//# sourceMappingURL=cookieManager.js.map